export function checkHideSpecPricing(plan: any): boolean {
  return (
    plan?.builder?.projects?.length &&
    plan.builder.projects[0].hide_spec_pricing
  )
}

export function checkHideHomePricing(plan: any): boolean {
  return (
    plan?.builder?.projects?.length &&
    plan.builder.projects[0].hide_home_pricing
  )
}
